// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Lod_","textarea":"styles_textarea__3QG3D"};